import { checks } from './checks/utils';

export const getStrength = (password: string) => {
	let multiplier = password.length > 5 ? 0 : 1;

	checks.forEach((check) => {
		if (!check.re.test(password)) {
			multiplier += 1;
		}
	});

	return Math.max(100 - (100 / (checks.length + 1)) * multiplier, 10);
};
